import type {ReactElement} from 'react'
import {logger} from 'tizra'
import {useMetaList, type UseMetaListProps} from './useMetaList'

const log = logger('MetaList')

type MetaListRender = (content: ReturnType<typeof useMetaList>) => ReactElement

interface MetaListProps extends UseMetaListProps {
  children?: MetaListRender
  render?: MetaListRender
}

export const MetaList = ({
  ref,
  children,
  render = children,
  ...rest
}: MetaListProps) => {
  const content = useMetaList(rest, ref)
  return render ? render(content) : content
}
